import * as React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';

import UserProfile from './UserProfiles//UserProfile';
import { useDispatch, useSelector } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';

interface UserProfilePageProps extends IAppPropsWithRoute {

};

function UserProfilePage(props: UserProfilePageProps): JSX.Element {
    const dispatch = useDispatch();
    //const { authStore } = useSelector((state: RootState) => state);
    React.useEffect(() => {
        dispatch(showNavbar(true));
    }, [])
   
    return (
        <React.Fragment>
             <UserProfile />
        </React.Fragment>
    );
}

export default React.memo(withRouter(UserProfilePage));